function SitesIcon(props) {
  let fillColor = 'currentColor'

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='28' height='30' viewBox='0 0 18.793 18.841' {...props}>
      <path
        id='shopping-cart-svgrepo-com'
        d='M13.573,17.705a2.088,2.088,0,1,0,2.088-2.041A2.088,2.088,0,0,0,13.573,17.705Zm-10.441,0A2.088,2.088,0,1,0,5.22,15.617,2.088,2.088,0,0,0,3.132,17.705Zm3.7-5.041,11.556-3.3a.589.589,0,0,0,.4-.532V3.088H4.176V1.418A.419.419,0,0,0,3.76,1H.417A.419.419,0,0,0,0,1.418V3.088H2.088L4.082,12.44l.094.985v1.722a.42.42,0,0,0,.418.418H18.376a.42.42,0,0,0,.418-.418V13.529H7.05C5.849,13.529,5.824,12.954,6.836,12.664Z'
        transform='translate(0 -1)'
        fill={fillColor}
      />
    </svg>
  )
}

export default SitesIcon
